<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <v-row>
        <v-col md="2">
          <ModuleHeader>CreditBook</ModuleHeader>
        </v-col>
        <v-col md="10" class="text-right">
          <v-btn color="green" elevation="0" dark @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon> Exportar a
            Excel</v-btn>
          <!-- <download-excel class="exportExcel"  type="xls" name="Membresias.xls" :data="excelData">
          </download-excel> -->
        </v-col>
      </v-row>
      <uv-data-table :config="config" :data="creditBooks" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <v-dialog v-model="Dialogs.sync" persistent max-width="390">
      <v-card>
        <v-card-title class="text-h5">
          Sincronización de datos
        </v-card-title>
        <v-card-text>Enviar actualización a los dispositivos Biometricos
          configurados en la red.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="Dialogs.sync = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="syncBiometric();">
            Enviar Sincronización
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal ref="modalForm" v-model="Dialogs.showModal" :showFooter="false">
      <CreditBookForm :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData" />
    </modal>
    <modal ref="modalMovs" v-model="Dialogs.showModalMov" :showFooter="false">
      <CreditBookMovimientos :edit="editMode" :key="formIndex" :dataEdit="editData"></CreditBookMovimientos>
    </modal>
  </div>
</template>



<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import CreditBookForm from "./CreditBookForm.vue";
import CreditBookMovimientos from "./CreditBookMovimientos.vue";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "MembresiasCRUD",
  components: {
    uvDataTable,
    CreditBookForm,
    modal,
    CreditBookMovimientos,
  },
  data() {
    return {
      formIndex: 0,
      editMode: false,
      editData: {},
      creditBooks: [],
      indexComponent: 1,
      Dialogs: {
        sync: false,
        showModal: false,
        showModalMov: false
      },
      config: {
        selectableRow: true,
        orderByCol: { Field: "NumeroMembresia", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addCreditBook",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarCreditBook",
            require: true,
          },
          {
            text: "Movimientos",
            icon: "lni lni-dollar",
            buttonId: "movimientosCreditBook",
            require: true,
          },

        ],
        fields: [
          {
            text: 'CreditBook',
            value: 'nom',
            canBeFiltered: true,
          },
          {
            text: "Cantidad",
            value: 'cnt',
          },
        ],
      },
      Catalogos: {
        PlanesMembresias: [],
        data_membresias: [],
      },
      aux: {
        membresiaToSync: {},
      },

    };
  },
  computed: {
    clients() {
      let clientes = {};
      let rowclientes = this.$store.getters.getClientes;
      rowclientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          clientes[element.id] = element;
        }
      });
      return clientes;
    },

    excelData() {
      /*let data = [];
      this.dataMembresias.forEach((m)=>{
        data.push({
          NumeroMembresia:m.code,
          Alias:m?.Apodo,
          Codigo:m?.Code?.Pos,
          Plan:m.PlanName,
          Titular:m.TitularName,
          Periodo:m.NombrePeriodo,
          Estatus:(m.Activo)?'ACTIVO':'INANCITVO',
          Deuda:parseFloat(m.Deuda.C).toFixed(2),
          Moneda:m.Deuda.M,
          Miembros:Object.keys(m.Clientes).length
        });
      })*/
      return [];
    },

  },
  methods: {
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Membresias.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    async getCreditBooks() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_DineroElectronico", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let cb = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      this.creditBooks = cb
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createCreditbook(data);
      } else if (doAction == "EDIT") {
        this.editarCreditBook(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addCreditBook") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar CreditBook");
        this.toggleModal(true);
      }
      if (buttonId == "editarCreditBook") {
        this.idSelected = idSelected[0];
        const cb = this.$pgsHelper.getById(
          this.creditBooks,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cb;
        this.$refs.modalForm.setTitle("Editar CreditBook");
        this.toggleModal(true);
      }
      if (buttonId == 'movimientosCreditBook') {
        this.idSelected = idSelected[0];
        const cb = this.$pgsHelper.getById(
          this.creditBooks,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cb;
        this.$refs.modalMovs.setTitle("Movimientos CreditBook");
        this.Dialogs.showModalMov = true;
      }

    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },

    createCreditbook(data) {
      this.$swal({
        title: "¿Deseas guardar este Creditbook?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-DineroElectronico-crearDineroElectronico", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.getCreditBooks();
            this.$swal({
              title: "Guardado",
              text: "El Creditbook se guardo correctamente",
              icon: "success",
            }).then(async () => {
              //this.Dialogs.sync = true;
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving creditBook",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editarCreditBook(data) {
      this.$swal({
        title: "¿Deseas guardar la información de este CreditBook?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Membresias-updateMembresia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El CreditBook se guardo correctamente",
              icon: "success",
            }).then(async () => {
              //this.Dialogs.sync = true;
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving CreditBook",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.Dialogs.showModal = open;
    },
  },
  beforeMount: function () { },
  mounted: async function () {
    this.getCreditBooks()
    /*this.Catalogos.data_membresias = await Membresia.getMembresiasList();
    this.Catalogos.data_membresias.forEach((element)=>{
      element.NumeroMembresia = element?.Code?.Pos;
      element.TitularName = this.$pgsHelper.getById(this.comp_clients,'id',element.Titular);
    })*/
  },
};
</script>
<style scoped>
.exportExcel {
  width: fit-content !important;
  position: absolute !important;
  right: 10px;
}
</style>
